/**
 * Validates a post-login redirect target. Prevents open redirects and auth pages.
 */
export function safeInternalNextParam(next: string | null | undefined): string | null {
  if (next == null || next === "") return null;
  const trimmed = next.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return null;
  if (trimmed.startsWith("/login") || trimmed.startsWith("/signup")) return null;
  return trimmed;
}

export function loginUrlWithReturn(pathname: string): string {
  const path = pathname && pathname !== "/login" && pathname !== "/signup" ? pathname : "/content";
  const safe = safeInternalNextParam(path) || "/content";
  return `/login?next=${encodeURIComponent(safe)}`;
}
